<template>
  <ubi-page-container>
    <template v-slot:page-actions>
      <el-button
        type="warning"
        class="inline"
        @click="dialogVisibleDesactiver = true"
      >
        <span @click="eventAnalytics('desactiver_diffusion')">{{ $t("portals.list.deactivateDiffusion") }}</span>
      </el-button>
      <el-button type="primary" class="inline" @click="dialogVisible = true">
        <span @click="eventAnalytics('activer_diffusion')">{{ $t("portals.list.activateDiffusion") }}</span>
      </el-button>
    </template>
    <div v-loading="loading"
         :element-loading-text="$t('portals.list.chargementDonnees')">
    <ubi-panel :title="$t('portals.list.portalSelection')">
      <el-dialog
        class="ValiderSelection"
        :title="$t('portals.list.portalSelectionActivateDiffusionTitle')"
        :visible.sync="dialogVisible"
      >
        <span>{{ $t("portals.list.portalSelectionActivateDiffusionText") }}</span>
        <br/>
        <br/>
        <el-checkbox v-if="isPromoteur && post.annonceParente == null"
                v-model="checkLots"
                true-label="oui"
                false-label="non"
        >{{ $t("portals.list.validateLotsDiffusion") }}
        </el-checkbox>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">{{ $t("portals.list.cancel") }}</el-button>
          <el-button type="primary" @click="validerSelection">{{ $t("portals.list.confirm") }}</el-button>
        </span>
      </el-dialog>

      <el-dialog
        class="DesactiverSelection"
        :title="$t('portals.list.portalSelectionDeactivateDiffusionTitle')"
        :visible.sync="dialogVisibleDesactiver"
      >
        <span>{{ $t("portals.list.portalSelectionDeactivateDiffusionText") }}</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleDesactiver = false">{{ $t("portals.list.cancel") }}</el-button>
          <el-button type="primary" @click="desactiverSelection">{{ $t("portals.list.confirm") }}</el-button>
        </span>
      </el-dialog>

      <el-dialog
              :title="$t('portals.list.portalSelectionDeactivationConfirmationTitle')"
              :visible.sync="validationDesactivation"
              width="30%"
              center>
        <span>{{ $t("portals.list.portalSelectionDeactivationConfirmationText") }}</span>
        <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="validationDesactivation = false">{{ $t("portals.list.close") }}</el-button>
        </span>
      </el-dialog>

      <el-row>
        <el-col :span="12">
          {{ $t("portals.list.dateLastDiffusion") }} :
          <strong v-if="dateDerniereDiffusion != null">{{dateDerniereDiffusion}}</strong>
          <strong v-else>{{ $t("portals.list.noDiffused") }}</strong>
          <br />
          <!--<br />{{ $t("portals.list.numberOfSelectedPortals") }} :
          <strong>{{nbPortailsSelectionnes}}/{{nbPortailsActifs}}</strong>-->
        </el-col>
        <el-col :span="12">
          <div class="text-muted" style="text-align: center;">
            <img v-if="post.photoPrincipale != null" :src="post.photoPrincipale.url" width="300" alt="" />
            <div v-else style="text-align: center;"><ubi-icon class="no-photo" name="camera" size='250' /></div>
            <br />
            <div v-if="post != null">{{post.titre}}</div>
          </div>
        </el-col>
      </el-row>
    </ubi-panel>
    <el-form label-position="top" @submit.prevent.native="fetchList">
      <ubi-panel style="background-color: #EBF3F2;">
        <ubi-search-container
          :filters="filters"
          :defaultFilter="this.filter.preset"
          v-on:resetfilter="doFilter('resetFilter')"
          @filter="doFilter"
          :more-opened="filter.advanced"
          @update:more-opened="advanced => setFilter({ advanced })"
        >
          <el-form-item :label="$t('general.filters.title')">
            <el-input
              type="text"
              @input="setSearch"
              :value="filter.search"
              :placeholder="$t('general.filters.titlePlaceholder')"
            />
          </el-form-item>
          <block-categories v-bind:excludedCategories="excludedCategories"></block-categories>

          <el-form-item :label="$t('general.filters.businessModel')">
            <el-radio-group :value="filter.gratuit" @input="setGratuit">
              <el-radio label="O">{{ $t("general.filters.businessModelFree") }}</el-radio>
              <el-radio label="N">{{ $t("general.filters.businessModelPaid") }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-slot:more>
            <el-row style="background-color: #EBF3F2;">
              <el-col :lg="12">
                <el-form-item :label="$t('general.filters.quota')">
                  <el-radio-group :value="filter.quota" @input="quota => addFilter({ quota })">
                    <el-radio label="O">{{ $t("general.filters.quotaWith")}}</el-radio>
                    <el-radio label="N">{{ $t("general.filters.quotaWithout")}}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :lg="12">
                <el-form-item :label="$t('general.filters.datePublication')">
                  <el-date-picker
                    type="daterange"
                    :value="filter.after || filter.before? [
                      filter.after || undefined,
                      filter.before || undefined
                    ] : null"
                    :start-placeholder="$t('general.filters.dateCreationStart')"
                    :end-placeholder="$t('general.filters.dateCreationEnd')"
                    @input="
                      dates => addFilter({ after: dates? dates[0] : null, before: dates? dates[1] : null})
                    "
                    format="dd/MM/yyyy"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </template>
        </ubi-search-container>

        <!-- Ici on insère les modales -->
      </ubi-panel>
      <ubi-panel class="PortalsSecondaryList">
        <template slot="header">
          <ubi-list-header
            slot="header"
            :limits="[8, 16, 32]"
            :page.sync="page"
            :limit.sync="limit"
            :total="results.count"
            :sort.sync="sort"
            :sortProperties="sortProperties"
          ></ubi-list-header>
        </template>
        <template slot="selection">
          <ubi-list-selection
            v-model="selected"
            arrow-down
            @select="doSelect"
          />
        </template>
        <template slot="actions">
          <el-button
            icon="export"
            size="mini"
            @click="exporter"
            v-if="!selected.length"
          >{{ $t("portals.list.exportResults") }}</el-button>
          <span v-else>
            <span>{{ $t("portals.list.forSelection") }} ({{ selected.length }}) : </span>
            <el-button class="inline" size="mini" @click="exporter">{{ $t("portals.list.export") }}</el-button>
          </span>
        </template>
        <ubi-list-footer
          slot="footer"
          :limits="[8, 16, 32]"
          :page.sync="page"
          :limit.sync="limit"
          :total="results.count"
        ></ubi-list-footer>
        <!-- Affichage du tableau en version bureau -->
        <el-table
          ref="tablePortalSelection"
          :data="results.list"
          @select="selectedChanged"
          @select-all="selectAllChanged"
        >
          <el-table-column type="selection" width="68" :selectable="canSelectRow" v-if="possedeSelectionPertinente"></el-table-column>
          <el-table-column type="selection" width="68" v-else></el-table-column>
          <el-table-column :label="$t('portals.list.columnDiffused')" width="68">
            <template v-slot="{ row: result }">
              <div v-if="possedeSelectionPertinente">
                <div v-if="result.selectionPortailPourAnnonceActive == true">
                  <div v-if="result.selectionPertinente != '0'">
                    <em class="el-icon-success text-success mr-2"  style="font-size:1.9em;"   />
                  </div>
                  <div v-if="result.selectionPertinente == '0'">
                    <el-tooltip placement="top-start">
                      <div slot="content" v-html="formatMessageTooltip(result.messageSelectionPertinente)">
                      </div>
                      <em class="el-icon-question text-warning mr-2"  style="font-size:1.9em;" />
                    </el-tooltip>
                  </div>
                </div>
                <div v-else>
                  <div v-if="result.selectionPertinente == '0'">
                    <el-tooltip placement="top-start">
                      <div slot="content" v-html="formatMessageTooltip(result.messageSelectionPertinente)">
                      </div>
                      <em class="el-icon-question text-warning mr-2"  style="font-size:1.9em;" />
                    </el-tooltip>
                  </div>
                </div>
              </div>
              <div v-else>
                <div v-if="result.selectionPortailPourAnnonceActive == true">
                  <em class="el-icon-success text-success mr-2"  style="font-size:1.9em;"   />
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('portals.list.columnLogo')" width="80">
            <template v-slot="{ row: result }">
              <img
                alt=""
                width="70"
                :src="result._embedded.diffuseur.logo"
                :srcset="result._embedded.diffuseur.logo"
              />
            </template>
          </el-table-column>
          <el-table-column :label="$t('portals.list.columnMyPortal')" width="170">
            <template v-slot="{ row: result }">
              <span></span>
              <el-link target="_blank" rel="noopener" :href="result.lienSiteUbiflow">
                {{result._embedded.diffuseur.nom}}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column :label="$t('portals.list.columnCategory')" width="120">
            <template v-slot="{ row: result }">
              <div
                v-for="(value, name, index) in result._embedded.diffuseur.categories"
                v-bind:key="index"
              >{{ value }}</div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('portals.list.columnSelectionType')">
            <template v-slot="{ row: result }">{{result.modeSelectionAutomatique}}</template>
          </el-table-column>

          <el-table-column :label="$t('portals.list.columnPublication')" width="120">
            <template v-slot="{ row: result }">
              <div v-if="result.dateMiseEnLigneAnnonce != null">
                <div>{{formatDate(result.dateMiseEnLigneAnnonce)}}</div>
                <small>à {{formatHeure(result.dateMiseEnLigneAnnonce)}}</small>
              </div>
              <div v-else>-</div>
            </template>
          </el-table-column>
        </el-table>
      </ubi-panel>
    </el-form>
    </div>
  </ubi-page-container>
</template>

<style lang="scss">
@import "@/theme/_bootstrap.scss";
.el-table-column--selection {
  width: 70px!important;
}
.PortalsSecondaryListr {
  &-selection {
    @extend .mb-5;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  @include media-breakpoint-down(md) {
    &-selection {
      flex-direction: column;
      align-items: flex-start;
    }
    &-export {
      align-self: flex-end;
    }
  }
}
.BouquetActiveModal {
  &-dialog .el-dialog {
    width: 670px;
    max-width: 90%;
  }

  &-container {
    > *:not(:first-child) {
      border-left: 1px solid $gray-200;
    }
  }

  &-actions {
    text-align: right;
  }
}
.el-loading-spinner{
  top:10%!important;
}
</style>

<script>
import { mapState, mapMutations } from 'vuex'
import moment from 'moment'
import {
  getPortals,
  exportCsvPortails,
  diffusionAnnonceActivate
} from '@/services/portals'
import { getPostById, getPosts } from '@/services/posts'
import { Dialog } from 'element-ui'
import blockCategories from './components/Categories'
import _uniq from 'lodash/uniq'

export default {
  name: 'PortalsSecondaryList',
  inject: ['browserContext'],
  components: { ElDialog: Dialog, blockCategories },
  data () {
    return {
      validationDesactivation: false,
      loading: false,
      dialogVisible: false,
      dialogVisibleDesactiver: false,
      bouquetActivated: false,
      post: null,
      postReference: this.$route.params.post,
      dateDerniereDiffusion: null,
      modalRemonterTeteDeListe: false,
      remonterTeteDeListeOption: false,
      nbPortailsSelectionnes: 0,
      user: null,
      activation: null,
      activationPortail: null,
      activationPortailModal: false,
      confirmDesactivationPortailModal: false,
      desactivationPortailModal: false,
      desactivationPortail: null,
      remontee: null,
      messageRemontee: null,
      limits: [10, 10 * 2, 10 * 5],
      selected: [],
      loaded: false,
      selectPortailPayant: false,
      selectPortailPayantResultat: false,
      photoPrincipale: null,
      nomCodePortail: null,
      emailCommercialPortail: 'test@test.com',
      nomPortail: null,
      portailIsPayant: null,
      checkLots: true,
      info: '',
      isBV: false,
      file: null,
      count: 0,
      offset: 0,
      page_count: 0,
      nbPortailsActifs: 0,
      sortProperties: {
        nom: this.$t('general.sort.name'),
        date: this.$t('general.sort.lastDiffusion'),
        contact: this.$t('general.sort.contacts')
      },
      filters: [
        { value: 'reset', label: this.$t('general.filters.allPortals') },
        {
          value: 'selected',
          label: this.$t('general.filters.onlySelectedPortals')
        },
        {
          value: 'unselected',
          label: this.$t('general.filters.onlyNoSelectedPortals')
        }
        // { value: "new", label: this.$t("Spécialisés « neufs »") }
      ],
      selection: null,
      selections: [],
      excludedCategories: 'réseaux sociaux,biens vendus'
    }
  },
  computed: {
    ...mapState('portalsSecondaryList', ['filter', 'results']),
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    possedeContactManager () {
      return this.sitimmoUser.possede_contact_manager
    },
    possedeSelectionPertinente () {
      return this.sitimmoUser.selection_pertinente
    },
    isPromoteur () {
      return this.sitimmoUser.metier === 'PROMOTEUR'
    },
    page: {
      get () {
        return this.filter.page
      },
      async set (value) {
        window.scrollTo(0, 0)
        this.setOffset((value - 1) * this.limit)
        this.setPage(value)
        await this.fetchList()
        this.toggleSelection()
        // return this.setPage(value);
      }
    },
    limit: {
      get () {
        return this.filter.limit
      },
      async set (value) {
        this.setLimit(value)
        this.setOffset(0)
        this.setPage(1)
        await this.fetchList()
        this.toggleSelection()

        // return this.setLimit(value);
      }
    },
    sort: {
      get () {
        return this.filter.sort
      },
      async set (value) {
        this.setSort(value)
        this.setOffset(0)
        this.setPage(1)
        await this.fetchList()
        this.toggleSelection()
        // return this.setSort(value);
      }
    }
  },
  beforeMount () {
    this.post = this.getPost()
  },
  mounted () {
    this.remonterTeteDeListeOption = this.getRemonterTeteDeListeDisplay()
    if (this.possedeContactManager === false) {
      delete this.sortProperties.contact
    }
    this.loaded = true
  },
  methods: {
    eventAnalytics (category) {
      this.$ga.event('selection_diffusions', 'clic', category, this.sitimmoUser.id)
    },
    async exporter () {
      let i = 0
      let strSelectedIds = null
      this.selected.forEach(function (idSelected) {
        if (i == 0) {
          strSelectedIds = idSelected
        } else {
          strSelectedIds = strSelectedIds + ',' + idSelected
        }
        i++
      })
      this.loading = true
      const filename = this.$t('portals.list.filenameExportAdsSelection')
      const res = await exportCsvPortails(this.filter, strSelectedIds, filename)
      this.$message(res)
      this.loading = false
    },
    canSelectRow (row, index) {
      if (this.possedeSelectionPertinente === true) {
        if ((row.selectionPertinente != '0' || row.selectionPortailPourAnnonceActive == true) && !row.modeSelectionAutomatique.includes('automatique')) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    },
    formatMessageTooltip (message) {
      let messageFinal = message
      messageFinal = messageFinal.replace('<br />', '<br/>')
      return messageFinal
    },
    convertDate: function (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    async validerSelection () {
      const tabJson = await this.generateTabJson(1)
      const response = await diffusionAnnonceActivate(tabJson)
      if (response.type === 'error') {
        // this.$message({message: this.$t("error.found"), type: 'error'});
        this.loading = false
        return false
      }
      this.dialogVisible = false
      this.getPost()
      this.selected = []
    },
    async desactiverSelection () {
      const tabJson = await this.generateTabJson(0)
      const response = await diffusionAnnonceActivate(tabJson)
      if (response.type === 'error') {
        // this.$message({message: this.$t("error.found"), type: 'error'});
        this.loading = false
        return false
      }
      this.dialogVisibleDesactiver = false
      this.getPost()
      this.validationDesactivation = true
      this.selected = []
    },
    async generateTabJson (activate) {
      const tabJson = {}
      tabJson.diffusions = new Array()
      if (this.selected.length > 0) {
        for (let i = 0; i < this.selected.length; i++) {
          const tempTab = {}
          tempTab.diffuseur = this.selected[i]
          tempTab.annonce = this.post.id
          tempTab.activate = activate
          tabJson.diffusions.push(tempTab)
          if (this.isPromoteur == true && this.post.annonceParente == null && this.checkLots == true) {
            const filterProgramme = {
              annonceParente: this.post.id,
              limit: 100
            }
            const responseLots = await getPosts(filterProgramme)
            const lots = responseLots.list
            lots.forEach(function (lot) {
              const tempTabLots = {}
              tempTabLots.diffuseur = this.selected[i]
              tempTabLots.annonce = lot.id
              tempTabLots.activate = activate
              tabJson.diffusions.push(tempTabLots)
            }, this)
          }
        }
      }
      const json_tab = JSON.stringify(tabJson)
      return json_tab
    },
    convertDateDerniereDiffusion: function (date) {
      return 'Le ' + moment.unix(date).format('MM/DD/YYYY à hh:mm')
    },
    ...mapMutations('portalsSecondaryList', [
      'setPage',
      'setLimit',
      'setSort',
      'setSearch',
      'setPostId',
      'setPortalsSelected',
      'setCategory',
      'setGratuit',
      'setFilter',
      'addFilter',
      'setResults',
      'setQuota',
      'setAfter',
      'setBefore',
      'resetFilter',
      'setOffset'
    ]),
    /*
    handleClose(done) {
        this.$confirm(this.$t("general.exitConfirmation"))
          .then(_ => {
            done();
          })
          .catch(_ => {});
    },
    */
    async fetchList () {
      // No need to interrupt promises when the router changes...
      this.loading = true

      // sometimes this.filter.active is null, for example doing a search with the filter "without quota",
      // so deactivate portals will be also returned. Here we confirm that we want only active portals.
      this.filter.active = true
      this.filter.excludedCategories = this.excludedCategories
      const portails = await getPortals(this.filter)
      if (portails.type == 'error') {
        // this.$message({message: this.$t("error.found"), type: 'error'});
        this.loading = false
        return false
      }
      this.setResults(portails)
      if (this.nbPortailsActifs == 0) {
        this.nbPortailsActifs = this.results.count
      }

      this.loading = false
    },
    async getPost () {
      this.post = await getPostById(this.postReference)
      if (this.post.type == 'error') {
        // this.$message({message: this.$t("error.found"), type: 'error'});
        this.loading = false
        return false
      }
      this.dateDerniereDiffusion = this.post.dateDerniereDiffusion
      this.photoPrincipale = this.post.photoPrincipale
      this.postId = this.post.id
      this.filter.postId = this.postId
      this.nbPortailsSelectionnes = this.post.nbPortailsActifs
      if (this.post.etat === 'V') {
        this.isBV = true
        this.doFilter('social-networks')
      } else {
        this.fetchList()
      }
    },
    getRemonterTeteDeListeDisplay: function () {
      let option = false
      if (
        this.sitimmoUser.remonter_annonces_tete_liste &&
              this.sitimmoUser.mode_remonter_annonces_tete_liste === 'MANUEL'
      ) {
        option = true
      }
      return option
    },
    async sendDisplayedInformationsPortal () {
      this.selectPortailPayant = false
    },
    formatDate: function (date) {
      return date.substring(0, 10)
    },
    formatHeure: function (date) {
      return date.substring(10)
    },
    doFilter (type) {
      this.filter.preset = type
      switch (type) {
        case 'reset':
          this.filter.diffuseurCodeNames = null
          this.setFilter({ active: true, postId: this.post.id })
          break
        case 'selected':
          this.filter.portalsSelected = true
          this.filter.postId = this.post.id
          this.filter.diffuseurCodeNames = null
          this.setFilter(this.filter)
          break
        case 'unselected':
          this.filter.portalsSelected = false
          this.filter.postId = this.post.id
          this.filter.diffuseurCodeNames = null
          this.setFilter(this.filter)
          break
        case 'social-networks':
          this.filter.portalsSelected = null
          this.filter.active = null
          this.filter.postId = this.post.id
          if (this.isBV == false) {
            this.filter.diffuseurCodeNames = 'FACEBOOK_POST_IMMO_BIENS_VENDUS,GOOGLE_MY_BUSINESS_IMMO_BIENS_VENDUS,INSTAGRAM_IMMO_BIENS_VENDUS,FACEBOOK_IMMO,FACEBOOK_POST_IMMO,INSTAGRAM_IMMO,GOOGLE_MY_BUSINESS_IMMO'
          } else {
            this.filter.diffuseurCodeNames = 'FACEBOOK_POST_IMMO_BIENS_VENDUS,GOOGLE_MY_BUSINESS_IMMO_BIENS_VENDUS,INSTAGRAM_IMMO_BIENS_VENDUS'
          }
          this.setFilter(this.filter)
          break
        case 'resetFilter':
          this.resetFilter()
          this.setFilter({ active: true, postId: this.post.id, category: null })
          break
      }
      if (this.loaded === true) {
        this.fetchList()
      }
    },
    doSelect (type) {
      switch (type) {
        case '*':
          const tmpSelection = this.results.list.map(item => item._embedded.diffuseur.nom_de_code)
          this.selected = _uniq(this.selected.concat(tmpSelection))
          this.toggleSelection()
          // this.$refs.tablePortalSelection.toggleAllSelection();
          break
        case null:
        default:
          this.selected = []
          // this.selection = "";
          this.$refs.tablePortalSelection.clearSelection()
      }
    },
    toggleSelection () {
      this.results.list.forEach(row => {
        if (this.selected.includes(row._embedded.diffuseur.nom_de_code)) {
          this.$refs.tablePortalSelection.toggleRowSelection(row, true)
        }
      })
    },
    selectAllChanged (selection) {
      // unselect all case
      if (!selection.length) {
        const self = this
        this.results.list.forEach(function (item) {
          const index = self.selected.indexOf(item._embedded.diffuseur.nom_de_code)
          if (index > -1) {
            this.selected.splice(index, 1)
          }
        }, self)
      } else { // select all case
        this.doSelect('*')
      }
    },
    selectedChanged (selection, row) {
      let add = false
      selection.forEach(function (item) {
        if (item._embedded.diffuseur.nom_de_code === row._embedded.diffuseur.nom_de_code) {
          add = true
        }
      })

      const index = this.selected.indexOf(row._embedded.diffuseur.nom_de_code)

      if (add) {
        if (index === -1) {
          this.selected.push(row._embedded.diffuseur.nom_de_code)
        }
      } else {
        if (index > -1) {
          this.selected.splice(index, 1)
        }
      }
    }
  }
}
</script>
